import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { buildFetchSitesQuery } from '@/features/sites'
import { fetchSitesList } from '@/features/sites/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'
import { SitesSearchSchema } from '@/routes/_protected/$tenantKey/settings/sites/-models'

export const Route = createFileRoute('/_protected/$tenantKey/settings/sites/')({
  validateSearch: (search) => parse(SitesSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          enable: true
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query = buildFetchSitesQuery(tenantKey, deps)
    return {
      authUser: auth.user,
      sites: await fetchSitesList(query, abortController.signal)
    }
  }
})
